import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {i18n, vuetify, nextFocus} from './plugins'
import Toast from 'vue-toastification'
import PortalVue from 'portal-vue'
import 'vue-toastification/dist/index.css'
import {Auth0Plugin} from './services/auth0plugin'
import {RawLocation} from 'vue-router'
import {sendErrorReport} from '@/utils/utils'

Vue.config.productionTip = false
Vue.use(PortalVue)
Vue.use(Toast, {hideProgressBar: true})
Vue.directive('next-focus', {inserted: nextFocus})
Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
  redirectUri: `${process.env.VUE_APP_WEB_ROOT_URL}/account/callback`,
  audience: process.env.VUE_APP_AUTH0_API_AUDIENCE,
  onRedirectCallback: (appState: {targetPath: RawLocation}) => {
    router.push(appState && appState.targetPath ? appState.targetPath : window.location.pathname)
  }
})

// Setup error handlers
Vue.config.errorHandler = (err, vm, info) => {
  sendErrorReport({
    event: 'error:vue',
    context: {
      error: `${err.name} ${err.message}\n${info}`,
      stack: err.stack as any
    }
  })
  console.error(err)
}

window.addEventListener('unhandledrejection', event => {
  sendErrorReport({
    event: 'error:unhandledrejection',
    context: {
      error: event.reason,
      stack: event.reason.stack
    }
  })
})

window.addEventListener('error', event => {
  sendErrorReport({
    event: 'error:js',
    context: {
      error: `${event.error}`,
      stack: event.error ? event.error.stack : `${event.message} ${event.filename}:${event.lineno}:${event.colno}`
    }
  })
})


// Disable service worker enabled before
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister()
    }
  })
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
